import { Component } from '@angular/core';
import { FirebaseService } from './services/firebase.service';
import { SharedService } from './shared.service';
import swal from 'sweetalert';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  user: any = null;
  title = 'AALS';
  isSignedIn = false;

  employee: any;

  constructor(public firebaseService: FirebaseService, private service: SharedService) {

  }


  ngOnInit()
  {
    if (localStorage.getItem('user') != null)
    {
      this.GetUserInfo();
      this.validateUser(this.user?.email);
      // this.isSignedIn = true;
      this.GetEmployee(this.user?.email);
    }
    else
    {
      this.isSignedIn = false;
    }
  }

  validateUser(email:string){
    this.service.GetEmployeeByEmail(email).toPromise().then(data =>
    {
      this.employee = data[0];
      if(this.employee)
      {
        this.isSignedIn = true;
        // swal("SUCCESS", "Successfully signed in..", "success")
      }
      else
      {
        this.logout()
        swal("Error", "This account is not registered in the Agilosoft database. Kindly Login from a registered account", "error");
      }
    });
  }

  GetUserInfo()
  {
    this.user = localStorage.getItem('userInfo') != null ? localStorage.getItem('userInfo') : '';
    this.user = JSON.parse(this.user);
  }

  async SignIn()
  {
    // this.user = await this.firebaseService.Login()
    await this.firebaseService.Login().then((data)=>
    {
      if (this.firebaseService.isLoggedIn == true)
      {
        this.isSignedIn = true;
        this.validateUser(this.user.email);
      }
      else
      {
        this.isSignedIn = false
      }
    })
  }


  async logout()
  {
    await this.firebaseService.logout()
    this.isSignedIn = false;
  }


  Test()
  {
    console.log(this.employee);
  }


  GetEmployee(email: string)
  {
    this.service.GetEmployeeByEmail(email).toPromise().then(data =>
    {
      this.employee = data[0];
      this.SetEmployeeObservable(this.employee);
    });
  }


  SetEmployeeObservable(emp: number)
  {
    this.service.ChangeEmployee(emp);
    //this.router.navigate(['/attendance-view'])
  }
}
